import * as React from "react";
import { PostReadyContent } from "@/interfaces";
import { createVideoThumbnailBlob } from "@/utils";
import { Card, Spinner } from "@/components/ui";
import { PostAnythingDialog } from "../PostAnythingDialog";

import useDisplayData from "./hooks";

interface OwnProps {
  post: PostReadyContent;
  refreshHandler: () => void;
}

const ReadyToPostCardFC: React.FC<OwnProps> = ({ post, refreshHandler }) => {
  const { contentId, contentType, mediaType, mediaUrl } = useDisplayData(post);

  const [thumbnail, setThumbnail] = React.useState<string | undefined>();
  const [showPostDialog, setShowPostDialog] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (mediaType) {
      const creativeUrl = mediaUrl;
      const urlPromise = mediaType === "IMAGE" ? Promise.resolve(creativeUrl) : createVideoThumbnailBlob(creativeUrl);
      urlPromise.then(url => {
        setThumbnail(url);
      });
    }
  }, [mediaUrl]);

  return (
    <>
      <Card
        onClick={() => setShowPostDialog(true)}
        className="w-[220px] h-[220px] rounded overflow-hidden cursor-pointer border border-slate-100 bg-slate-50 hover:shadow-md hover:scale-[1.01] active:scale-[0.99] transition-all duration-200 select-none group/card shrink-0 p-0"
      >
        <div className="relative size-full overflow-hidden rounded">
          {thumbnail ? (
            <img
              src={thumbnail}
              alt="Ready to post preview"
              className="size-full object-cover transition-transform duration-200 group-hover/card:scale-105"
            />
          ) : (
            <div className="size-full flex items-center justify-center text-slate-300">
              <Spinner />
            </div>
          )}
        </div>
      </Card>

      {showPostDialog && (
        <PostAnythingDialog
          opened={showPostDialog}
          thumbnail={thumbnail || ""}
          contentId={contentId}
          contentType={contentType}
          closeHandler={() => {
            setShowPostDialog(false);
            refreshHandler();
          }}
        />
      )}
    </>
  );
};

export const ReadyToPostCard = ReadyToPostCardFC;
